import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import img01 from './../assets/solutions_products/solution.png'; // Adjust the path as necessary
import 'animate.css/animate.min.css'; // Import animate.css for animations



export default function SolutionProduct() {
    return (
        <Container className='agile'>
            <h2 className="text-center title">Solutions & Products</h2>
            <Row>
                <div className="responsive-title">From Problem Solving to</div>
                <div className="responsive-title">Performance Scaling, Powered by Trust</div>

            </Row>
            <Row className='mt-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__fadeInUp" duration={.5} offset={100}>

                    <p className='text-center mb-4'>
                        At Exel, we don't just deliver technology we orchestrate value driven digital ecosystems through strategic collaborations with world class platforms, service innovators, and industry aligned business units. Each product and service we offer is crafted to solve real business pain points, accelerate transformation, and unlock measurable growth.
                    </p>
                    <p className='text-center mb-4'>
                        From cyber defense to customer engagement, our approach blends the right tools, the right people, and the right strategy to not only solve today’s challenges, but to future proof your business for tomorrow.
                    </p>
                    <p className='text-center mb-4' style={{ fontWeight: 'bold' }}>
                        This is more than IT. This is technology with purpose, designed for impact.
                    </p>
                </AnimationOnScroll>
            </Row>
            <Row className='mt-4 d-none d-md-flex justify-content-center'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__fadeInUp" duration={.5} offset={100}>
                    <div className='hover-zoom bg-white'>
                        <img src={img01} alt="" style={{ borderRadius: '25px', width: '100%' }} />
                    </div>
                </AnimationOnScroll>
            </Row>


        </Container>
    )

}